import { BaseGrassetto } from '@lucan/base-ui'
import Sottotitolo from './Sottotitolo'

export default function ChiaveValore(props) {
  const { chiave, valore, ...rest } = props

  return (
    <Sottotitolo {...rest}>
      <BaseGrassetto>{chiave}:</BaseGrassetto>&nbsp;{valore}
    </Sottotitolo>
  )
}